import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=71aefb0c&"
import script from "./BookItem.vue?vue&type=script&lang=js&"
export * from "./BookItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports